// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"live_scrollbar__1s9dK"};